import { Resource_AppointmentMsg } from '@/generated/graphql';
import { Card } from 'antd';
import Title from 'antd/lib/typography/Title';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface AppointmentGroupAppointmentProps {
  appointment: Nullable<Resource_AppointmentMsg>;
}

export const AppointmentGroupAppointment: FC<AppointmentGroupAppointmentProps> = ({
  appointment,
}) => {
  const { formatMessage } = useIntl();

  const quota = appointment?.groupAppointmentQuota;
  const attendeeCount = appointment?.attendeeCount;

  return (
    <Card>
      <Title level={3} style={{ fontWeight: 'bold', marginBottom: 10 }}>
        {formatMessage({ id: 'appointment.group-appointment' })}
      </Title>

      <p>{formatMessage({ id: 'appointment.group-appointment.description' })}</p>
      {quota && attendeeCount && (
        <p>
          {formatMessage(
            { id: 'appointment.group-appointment.quota' },
            { quota, count: attendeeCount },
          )}
        </p>
      )}
    </Card>
  );
};
